import React from 'react';
import styled from '@emotion/styled';
import { Row, Col } from 'ds/components/grid-system';
import { useScreenBreakpoint } from 'consts/breakpoints';
import { ListingCardPlaceholder } from 'components/cards/listing/ListingCardPlaceholder';
import { makePlaceholdersArray } from 'utils/placeholders';


const LoadingCardsWrapper = styled.div`
  overflow: hidden;
  margin: 0;
`;

const SectionHeaderSkeleton = styled.div`
  ${({ theme }) => `
    width: 225px;
    height: 20px;
    margin: 0 ${theme.spacing(1)} ${theme.spacing(1)};
    margin-bottom: ${theme.spacing(1)};
    border-radius: ${theme.borderRadius.tiny};
    background-color: ${theme.colors.neutrals.grey9};
  `}
`;

const SectionSubHeaderSkeleton = styled.div`
  ${({ theme }) => `
    width: 114px;
    height: 20px;
    margin: 0 ${theme.spacing(1)} ${theme.spacing(2)};
    border-radius: ${theme.borderRadius.tiny};
    background-color: ${theme.colors.neutrals.grey9};
  `}
`;

export const CardsSkeleton: React.FC<{ containerRef?: React.Ref<HTMLDivElement>, disableAnimation?: boolean }> = (props) => {
  const breakpoint = useScreenBreakpoint();

  const listingCardPlaceholderWithColumn = (
    <Col>
      <ListingCardPlaceholder disableAnimation={props.disableAnimation} />
    </Col>
  );

  let content: React.ReactNode = null;

  switch (breakpoint) {
    case 1:
      content = listingCardPlaceholderWithColumn;
      break;
    case 2:
      content = makePlaceholdersArray(2, listingCardPlaceholderWithColumn);
      break;
    case 3:
    case 4:
      content = makePlaceholdersArray(3, listingCardPlaceholderWithColumn);
      break;
    case 5:
      content = makePlaceholdersArray(4, listingCardPlaceholderWithColumn);
      break;
  }

  return (
    <LoadingCardsWrapper ref={props.containerRef}>
      <Row>
        <Col>
          <SectionHeaderSkeleton />
          <SectionSubHeaderSkeleton />
        </Col>
      </Row>
      <Row>
        {content}
      </Row>
    </LoadingCardsWrapper>
  );
};
